// extracted by mini-css-extract-plugin
export default {"container":"_2wVJZe8m","selected":"_3d-TBwDK","project":"coWQClm-","thumbnail":"_3qcM6lfS","title":"_1MxFM-PA"};